import { Button, Drawer, Empty, List, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface CatalogTile {
  id: string
  title: string
}

interface AddTileDrawerProps {
  open: boolean
  catalogTiles: CatalogTile[]
  onAdd: (id: string) => void
  onClose: () => void
}

export const AddTileDrawer = ({
  open,
  catalogTiles,
  onAdd,
  onClose
}: AddTileDrawerProps) => {
  const { t } = useTranslation()

  return (
    <Drawer
      title={t("portfolio.catalog.title", "Available Tiles")}
      open={open}
      onClose={onClose}
      mask={false}
      width="min(420px, 100vw)"
      destroyOnHidden
    >
      {catalogTiles.length === 0 ? (
        <Empty description={t("portfolio.catalog.empty", "No tiles left to add")} />
      ) : (
        <div data-guide-target="dashboard-add-tile-list">
          <List
            size="small"
            dataSource={catalogTiles}
            renderItem={(tile) => (
              <List.Item
                key={tile.id}
                actions={[
                  <Button
                    key="add"
                    type="link"
                    size="small"
                    onClick={() => onAdd(tile.id)}
                  >
                    {t("portfolio.catalog.add", "+ Add")}
                  </Button>
                ]}
              >
                <Typography.Text>{tile.title}</Typography.Text>
              </List.Item>
            )}
          />
        </div>
      )}
    </Drawer>
  )
}
